module.exports = __webpack_public_path__ + "static/media/mortagua-1.2ad14634.jpg";